function createFetchQueue(concurrency, timeout) {
  const queue = [];
  let active = 0;
  let paused = false;
  const activeControllers = new Set();

  function next() {
    while (!paused && active < concurrency && queue.length > 0) {
      active++;
      const { fn, resolve, reject } = queue.shift();
      const controller = new AbortController();
      activeControllers.add(controller);
      const timer = setTimeout(() => {
        controller.abort();
        reject(new Error('Queue timeout'));
      }, timeout);
      fn(controller.signal)
        .then(resolve, reject)
        .finally(() => {
          clearTimeout(timer);
          activeControllers.delete(controller);
          active--;
          next();
        });
    }
  }

  function enqueue(fn, priority = false) {
    return new Promise((resolve, reject) => {
      if (priority) {
        queue.unshift({ fn, resolve, reject });
      } else {
        queue.push({ fn, resolve, reject });
      }
      next();
    });
  }

  enqueue.pause = () => { paused = true; };
  enqueue.resume = () => { paused = false; next(); };
  enqueue.abortActive = () => {
    activeControllers.forEach(c => c.abort());
  };
  // Clear all pending (not yet started) requests and abort active ones
  enqueue.clear = () => {
    while (queue.length > 0) {
      const { reject } = queue.shift();
      reject(new Error('Queue cleared'));
    }
    activeControllers.forEach(c => c.abort());
  };

  return enqueue;
}

export const iiifFetchQueue = createFetchQueue(3, 10000);
